import { Component, Input } from '@angular/core';
import { HistoryItem } from 'src/app/models/history-user';
import { BaseButtonComponent } from '../base-button';

@Component({
  selector: 'app-certificate-button',
  templateUrl: './certificate-button.component.html',
  styleUrls: ['./certificate-button.component.scss', '../base-button.scss'],
})
export class CertificateButtonComponent extends BaseButtonComponent {
  @Input()
  isMoreOption: string;

  @Input()
  historyItem: HistoryItem;

  @Input()
  certificateUrl: string;

  openCertificate(url: string) {
    window.open(url, '_blank', 'noopener');
  }
}
